import api from 'api/apiInstance';

export function practiceAdminUnassignApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
